import React from 'react'
import { Logo } from '@/shared/components/Logo'

export function SidebarHeader() {
    return (
        <div className="h-full flex items-center">
            <Logo />
        </div>
    )
}
